module.exports = __webpack_public_path__ + "static/bar04_3-a83f36482c8c566f1e2cbe87b384704d.png";